import { ContentMenu } from './content-menu'
import { AccessLevel, Branch, Content, Folder, Genus, Node, Secure, Site } from '@xanadu/model';
import { MenuBuilder } from './menu-builder';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ContentMenuBuilder extends MenuBuilder {

    public Build(node: Node, clipboard: Node): ContentMenu {
        const menu = new ContentMenu();
        if (!node.isNew) {
            if (node instanceof Site) {
                this.forSite(menu, node);
            } else if (node instanceof Folder) {
              this.forFolder(menu, node);
            } else if (node instanceof Genus) {
                this.forGenus(menu, node);
            } else if (node instanceof Content) {
                this.forContent(menu, node);
            }
        }

        this.forEdit(menu, node, clipboard);

        return menu;
    }

    private forSite(menu: ContentMenu, node: Node): void {
        const site = node as Site;
        if (site) {
            menu.folder = menu.genus = site.accessLevel > AccessLevel.List;
        }
    }

    private forGenus(menu: ContentMenu, node: Node): void {
        const genus = node as Genus;

        if (!node.parentId) {
            menu.site = genus.accessLevel > AccessLevel.List;
        } else {
            menu.folder = genus.accessLevel > AccessLevel.List;
            menu.content = genus.accessLevel > AccessLevel.List;
        }
    }

    private forFolder(menu: ContentMenu, node: Node): void {
        const folder = node as Folder;
        menu.genus = !folder.prototypeId && folder.accessLevel > AccessLevel.List;
        menu.folder = folder.accessLevel > AccessLevel.List;
        menu.content = !!folder.prototypeId && folder.accessLevel > AccessLevel.List;
    }

    private forContent(menu: ContentMenu, node: Node): void {
    }

    private forEdit(menu: ContentMenu, node: Node, clipboard: Node): void {
        const secure = node instanceof Content ? node.parent as Secure : node as Secure;
        const hasEdit = secure.accessLevel > AccessLevel.List;

        menu.delete = !!node.parentId && (node instanceof Content || secure.canDelete) && hasEdit;
        menu.cut = !!node.parentId && !(node instanceof Site) && hasEdit;
        menu.copy = !!node.parentId && (node instanceof Content);
        menu.paste = clipboard && !clipboard.childOf(node) && clipboard.fit(node as Branch) && hasEdit && !node.isNew;
    }
}
